module.exports = __webpack_public_path__ + "static/media/bell-tower-2.5784b083.jpg";